import { render, staticRenderFns } from "./drop.vue?vue&type=template&id=96c8a57c&"
import script from "./drop.vue?vue&type=script&lang=js&"
export * from "./drop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96c8a57c')) {
      api.createRecord('96c8a57c', component.options)
    } else {
      api.reload('96c8a57c', component.options)
    }
    module.hot.accept("./drop.vue?vue&type=template&id=96c8a57c&", function () {
      api.rerender('96c8a57c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/drop.vue"
export default component.exports